import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHomeRoofSmileFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.9453 14.6758C14.9653 15.9628 13.5273 16.7008 12.0003 16.7008C10.4743 16.7008 9.03627 15.9628 8.05427 14.6758C7.80327 14.3468 7.86627 13.8758 8.19627 13.6248C8.52527 13.3738 8.99627 13.4368 9.24727 13.7668C9.94327 14.6778 10.9453 15.2008 12.0003 15.2008C13.0543 15.2008 14.0573 14.6778 14.7523 13.7668C15.0033 13.4368 15.4743 13.3738 15.8033 13.6248C16.1323 13.8758 16.1963 14.3458 15.9453 14.6758ZM21.6203 9.30176L14.0923 3.34076C12.8603 2.37076 11.1393 2.37276 9.90527 3.34276L2.37927 9.30176C1.94627 9.64476 1.87327 10.2738 2.21527 10.7078C2.55927 11.1398 3.18827 11.2118 3.62027 10.8708L3.74627 10.7708V17.5768C3.74627 19.6768 5.45727 21.3858 7.56027 21.3858H16.4403C18.5423 21.3858 20.2533 19.6768 20.2533 17.5768V10.7708L20.3793 10.8708C20.5633 11.0158 20.7813 11.0868 20.9993 11.0868C21.2943 11.0868 21.5863 10.9568 21.7843 10.7078C22.1273 10.2738 22.0533 9.64476 21.6203 9.30176Z",
		fill: "currentColor"
	})
});
export default SvgHomeRoofSmileFill;
